<div
  class="pill-tabs"
  role="tablist"
  [attr.aria-label]="ariaLabel"
  [style.--pill-tabs-columns]="gridColumns">
  <button
  type="button"
  role="tab"
  class="pill-tab"
  *ngFor="let tab of tabs; let index = index"
  [class.active]="activeIndex === index"
  [attr.aria-selected]="activeIndex === index"
  (click)="selectTab(index)">
    <span>{{ tab.label }}</span>
    <span class="count" *ngIf="tab.count !== undefined">{{ tab.count }}</span>
  </button>
</div>
